let CN = require('@/assets/common/lang/cn')
let EN = require('@/assets/common/lang/en')

const changeTitle = function(title) {
    let pathName = top.location.href && top.location.href.match(/#\/(\w+)(\/|\?)?/)[1]
    var title
    switch(pathName) {
        case 'findDept':
            title = localStorage.getItem("i18n") === 'EN' ? EN.lang.zks : CN.lang.zks
            break
        case 'findDoc':
            title = localStorage.getItem("i18n") === 'EN' ? EN.lang.zys : CN.lang.zys
            break
        case 'helpnavlist':
            title = localStorage.getItem("i18n") === 'EN' ? EN.lang.bzzx : CN.lang.bzzx
            break
        case 'personCenter':
            title = localStorage.getItem("i18n") === 'EN' ? EN.lang.grzx : CN.lang.grzx
            break
        case 'twzx':
          title = localStorage.getItem("i18n") === 'EN' ? EN.lang.twzx : CN.lang.twzx
          break
        default:
            title = localStorage.getItem("i18n") === 'EN' ? EN.lang.hlwyy : CN.lang.hlwyy
    }
    document.title = title
    document.body.scrollTop = 0
}
export {
    changeTitle
}



// WEBPACK FOOTER //
// ./src/util/index.js